import React from 'react';
import { makeStyles } from '@material-ui/core';

import GridContainer from '../../../components/Grid/GridContainer';
import CustomInput from '../../../components/CustomInput/CustomInput';
import Button from '../../../components/CustomButtons/Button';
import CardHeader from '../../../components/Card/CardHeader';
import CardBody from '../../../components/Card/CardBody';
import CardFooter from '../../../components/Card/CardFooter';
import GridItem from '../../../components/Grid/GridItem';
import Error from '../../../components/Error';
import TextField from '@material-ui/core/TextField';

const UserLoginForm = ({ formik }) => {
  const classes = useStyles();
  return (
    <form onSubmit={formik.handleSubmit}>
      
      <CardBody style={{ paddingTop: '40px', paddingBottom: '10px' }}>
        <GridContainer>
          <GridItem xs={12}>
            <TextField
              style={{ paddingBottom: '8%' }}
              variant="outlined"
              fullWidth
              label="Email"
              name="username"
              inputProps={{
                ...formik.getFieldProps('username'),
                type: 'text',
                placeholder: 'example@domain.com',
                autoComplete: 'username',
              }}
              formControlProps={{
                fullWidth: true,
              }}
            />
            {formik.touched.username && formik.errors.username && (
              <Error msg={formik.errors.username} />
            )}
          </GridItem>
          <GridItem xs={12}>
            <TextField
              style={{ paddingBottom: '10%' }}
              variant="outlined"
              fullWidth
              label="Password"
              name="password"
              inputProps={{
                ...formik.getFieldProps('password'),
                placeholder: '********',
                type: 'password',
                autoComplete: 'current-password',
              }}
              formControlProps={{
                fullWidth: true,
              }}
            />
            {formik.touched.password && formik.errors.password && (
              <Error msg={formik.errors.password} />
            )}
          </GridItem>
        </GridContainer>
        <Button
          fullWidth
          style={{ background: '#800054', borderRadius: '10px' }}
          disabled={
            (formik.isValid && !formik.dirty) ||
            (formik.dirty && !formik.isValid)
          }
          type="submit"
        >
          Login
        </Button>
      </CardBody>
    </form>
  );
};

const useStyles = makeStyles({
  cardCategoryWhite: {
    color: 'rgba(255,255,255,.62)',
    margin: '0',
    fontSize: '14px',
    marginTop: '0',
    marginBottom: '0',
  },
  cardTitleWhite: {
    color: '#FFFFFF',
    marginTop: '0px',
    minHeight: 'auto',
    fontWeight: '300',
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: '3px',
    textDecoration: 'none',
  },
});

export default UserLoginForm;
